import {List, ListItem} from '@luminopia/react-toolbox/lib/list'
import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar'
import {PlainLink} from 'core/components/link'
import {IFormFields, Approval, approvalFormFactory} from 'study_reviewer/components/approvals'
import {IDeleteRequestFormFields, deleteFormFactory} from 'study_reviewer/components/deletes'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import Card from 'study_reviewer/components/Card'
import {ReviewerControls, ReviewerSummary} from 'study_reviewer/components/reviewers'
import * as routes from 'study_reviewer/routes'
import {
  IState,
  selectReviewer,
  approveRequest,
  deleteRequest,
} from '../store'
import { getReviewersRequest, model as ReviewersModel } from 'study_reviewer/store/reviewers'
import * as classNames from './PhysicianPage.css'

interface IStateProps {
  reviewer?: ReviewersModel.IReviewer
  isFetching: boolean
}
interface IDispatchProps {
  onMount?: () => void
}
export interface IRouteParams {
  npi: string
}
interface IOwnProps extends RouteComponentProps<IRouteParams> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

const systemId = '86e65f74-b01f-11ed-b5a1-07ac1c5a3a64'
const APPROVE_FORM_NAME = 'approval'
const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
  dispatch(approveRequest(systemId, data, APPROVE_FORM_NAME))
}
const DELETE_REQUEST_FORM_NAME = 'delete-request'
const onDeleteRequestSubmit = (data: IDeleteRequestFormFields, dispatch: Dispatch<void>) => {
  dispatch(deleteRequest(data, DELETE_REQUEST_FORM_NAME))
}
const ApprovalForm = approvalFormFactory({formName: APPROVE_FORM_NAME, onSubmit})
const DeleteForm = deleteFormFactory({formName: DELETE_REQUEST_FORM_NAME, onSubmit: onDeleteRequestSubmit})

class ApprovalPageView extends React.Component<IProps, {}> {
  public render() {
    if (this.props.isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />
    } else if (!this.props.reviewer) {
      return <h1>Reviewer not found</h1>
    }

    const {
      id,
      npi,
      firstName,
      lastName,
      isApproved,
      email,
      createdTime,
      approvedTime,
      isAdmin,
    } = this.props.reviewer

    const systemId = this.props.reviewer.id

    return (
      <div>
        <Card title={`${firstName} ${lastName}`} subtitle='name' icon='person_outline'>
          <div className={classNames.headerContainer}>
              <ReviewerSummary
              npi={npi}
              isApproved={isApproved}
              />
            </div>
            <List>
            <ListItem
              legend='NPI'
              caption={npi}
              leftIcon='fingerprint'
              ripple={false}
            />
            <ListItem
              legend='Email'
              caption={email}
              leftIcon='person'
              ripple={false}
            />
            <ListItem
              legend='Approved'
              caption={isApproved ? 'yes' : 'no'}
              leftIcon='check_box'
              ripple={false}
            />
            <ListItem
              legend='Registered On'
              caption={createdTime}
              leftIcon='schedule'
              ripple={false}
            />
            <ListItem
              legend='Approved On'
              caption={approvedTime}
              leftIcon='update'
              ripple={false}
            />
            <ListItem
              legend='Admin (Luminopia Internal Use Only)'
              caption={isAdmin ? 'yes' : 'no'}
              leftIcon='verified_user'
              ripple={false}
            />
          </List>
          {!isApproved &&
            <Approval
              {...routeProps<IProps, IRouteParams>(this.props)}
              renderForm={() => (
                <ApprovalForm initialValues={{
                  email: email,
                  id: id,
                  approvedTime: '',
                }}
                />
              )}
            />
          }
          {!isApproved &&
            <DeleteForm initialValues={{ id }} />
          }
        </Card>
      </div>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) this.props.onMount()
  }
}

const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
  const npi = ownProps.match.params.npi
  const reviewer = selectReviewer(state, npi)
  const isFetching = state.reviewers.isFetching

  if (!reviewer) {
    return {
      isFetching,
    }
  }
  return {
    reviewer,
    isFetching,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>, ownProps: IOwnProps): IDispatchProps => ({
  onMount: () => {
    dispatch(getReviewersRequest())
  },
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalPageView)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/PhysicianDetailPage.tsx